// export const LOGIN = 'LOGIN';

export default {
  // [LOGIN](state) {
  //   state.pending = true;
  // }
};
